module.exports = __webpack_public_path__ + "img/a9b49521023.30dae8e8.jpg";